import React from "react";
import IconRenderer from "../../../components/IconRenderer";
import {
  FaChartLine,   // Sales trend
  FaMoneyBillWave, // Expenses
  FaBalanceScale, // Gross Profit
  FaChartPie,    // EBITA
  FaDollarSign   // Net Profit
} from "react-icons/fa";

// Simple placeholder chart
const PlaceholderChart = ({ color, direction }) => {
  const lineStyle = {
    fill: "none",
    stroke: color,
    strokeWidth: 2,
  };

  const pathD =
    direction === "up"
      ? "M 5 20 Q 15 5 25 20"
      : "M 5 5 Q 15 20 25 5";

  return (
    <svg width="30" height="25" viewBox="0 0 30 25">
      <path d={pathD} style={lineStyle} />
    </svg>
  );
};

const MetricItem = ({ label, value, trend, isPositive, showArrow = true, icon: Icon }) => {
  const trendColor = isPositive ? "#00C853" : "#D50000";
  const arrow = isPositive ? "▲" : "▼";
  const chartDirection = isPositive ? "up" : "down";

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "16px 0",
        borderBottom: "1px solid #e0e0e0",
      }}
    >
      {/* Left: icon + label */}
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        {Icon && <Icon style={{ fontSize: "1.4rem", color: "#555" }} />}
        <span style={{ fontSize: "14px", fontFamily: "Inter" }}>{label}</span>
      </div>

      {/* Right: value + trend + mini chart */}
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <div style={{ textAlign: "right" }}>
          <div style={{ fontSize: "14px", fontWeight: 500 }}>{value}</div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              color: trendColor,
              marginTop: "-4px",
              fontSize: "12px",
              fontWeight: "bold",
            }}
          >
            {showArrow && <span style={{ marginRight: "2px" }}>{arrow}</span>}
            {trend}
          </div>
        </div>
        </div>
    </div>
  );
};

const PerformanceHighlights = () => {
  const metrics = [
    { label: "Sales Revenue Q4 2024", value: "$115.60", trend: "+7.99%(YOY)", isPositive: true, icon: FaChartLine },
    { label: "Total Expenses Q4 2024", value: "$45.60", trend: "-1.16%(YOY)", isPositive: false, icon: FaMoneyBillWave },
    { label: "Gross Profit Q4 2024", value: "$81.27", trend: "+12.26(YOY)", isPositive: true, icon: FaBalanceScale },
    { label: "Net Profit (EBITA) Q4 2024", value: "$70.54 ", trend: "+14.79%(YOY)", isPositive: true, icon: FaChartPie },
    { label: "Profit Margin Q4 2024", value: "$58.79", trend: "+6.54%(YOY)", isPositive: true, icon: FaDollarSign },
  ];

  return (
    <div
      style={{
        borderRadius: "16px",
        boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
        backgroundColor: "#fff",
        padding: "16px",
        fontFamily: "Inter",
      }}
    >
      {/* Header */}
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <h3
            style={{
              fontFamily: "Inter",
              fontWeight: "bold",
              fontSize: "16px",
              color: "black",
              margin: 0,
            }}
          >
            Performance Highlights
          </h3>
          <button
            style={{
              background: "none",
              border: "none",
              color: "var(--card-secondary-color)",
              fontSize: "var(--card-action-font-size)",
             
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
            title="View More"
          >
            View More
            <IconRenderer keyword={"right_arrow_minii"} />
          </button>
        </div>
        <span
          style={{
            fontSize: "12px",
            fontWeight: 500,
            marginTop: "4px",
            textAlign:'left',
            opacity: 0.9,
          }}
        >
          As on 10-01-2025
        </span>
      </div>

      {/* Metrics */}
      <div style={{ marginTop: "12px" }}>
        {metrics.map((metric, index) => (
          <MetricItem
            key={index}
            label={metric.label}
            value={metric.value}
            trend={metric.trend}
            isPositive={metric.isPositive}
            showArrow={true}
            icon={metric.icon}
          />
        ))}
      </div>
    </div>
  );
};

export default PerformanceHighlights;
